import { render, staticRenderFns } from "./InfoPopover.vue?vue&type=template&id=0906cd6c&scoped=true&"
import script from "./InfoPopover.vue?vue&type=script&lang=ts&"
export * from "./InfoPopover.vue?vue&type=script&lang=ts&"
import style0 from "./InfoPopover.vue?vue&type=style&index=0&id=0906cd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0906cd6c",
  null
  
)

export default component.exports